<script>
export default {
    name: "MoreMenuComponent",
    data() {
        return {
            state: false,
        };
    },
};
</script>

<template>
    <v-menu v-model="state" tile offset-y min-width="200">
        <template #activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs" :isActive="state" />
        </template>
        <v-list>
            <v-list-item color="primary" to="/pruefkleber">
                <v-list-item-icon>
                    <v-icon>mdi-sticker-check-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Prüfkleber</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
